import React, { useEffect, useRef } from "react";
import "./ringsCatrinel.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function RingsCatrinel() {
  gsap.registerPlugin(ScrollTrigger);
  return (
    <>
      <div className="ringsCatrinel-main">
        <div className="component-content rings-component-content">
          <div className="component-content-text">
            <p>
              {" "}
              <i>
                ”Połysk i ogień. Brylanty, kamienie szlachetne i perfekcja
                szlifów. Ozdabia Cię ekskluzywna pewność siebie. Kolekcja "PURE
                DIAMONDS" oznajmia, że świat leży Ci u stóp. Na zawsze.”
              </i>
            </p>
          </div>
          <div className="component-content-title rings-component-title">
            <p>Natalia Szroeder,</p>
            <p className="ambasador"> Ambasadorka TEILOR</p>
          </div>
        </div>
      </div>
      <div className="ringsCatrinel-separator">
        <a href="https://www.teilor.pl/pure-diamonds.html">
          <div className="pure-diamonds-btn">
            ODKRYJ KOLEKCJĘ THE PURE DIAMONDS
          </div>
        </a>
      </div>
    </>
  );
}
